export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/logo.svg?dfa25b22cdb9dbcf50ce8101e13fb686";